import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';

import 'flickity-imagesloaded';
import {initFlickityResizeClass} from '../utils/flickity';

const selectors = {
  slider: '[data-featured-products-slider]',
  pageButton: '[data-page-button]',
};

const sectionType = 'featured-products';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      const container = this.container;
      const slider = container.querySelector(selectors.slider);
      if (!slider) return;

      const sliderPageButtons = container.querySelectorAll(selectors.pageButton);

      const resetSelectorButtons = () => {
        sliderPageButtons.forEach((button) => {
          button.classList.remove('is-selected');
        });
      };

      // Check if slider is enabled in section settings
      const enableMarquee = this.container.dataset.enableMarquee === 'true';

      initFlickityResizeClass();

      // Base configuration shared between both modes
      const baseConfig = {
        accessibility: true,
        resize: true,
      };

      // Configuration for when slider is enabled
      const enabledConfig = {
        ...baseConfig,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        freeScroll: true,
        draggable: false,
        resize: false,
        percentPosition: false,
        selectedAttraction: 0.015,
        friction: 0.25,
      };

      // Configuration for when slider is disabled
      const disabledConfig = {
        ...baseConfig,
        freeScroll: false,
        prevNextButtons: false,
        pageDots: true,
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: 'left',
        groupCells: true,
        watchCSS: true,
        contain: true,
        on: {
          ready() {
            if (sliderPageButtons) {
              sliderPageButtons.forEach((button) => {
                const buttonSlideIndex = parseInt(button.dataset.pageButton, 10);
                button.addEventListener('click', () => {
                  this.select(buttonSlideIndex);
                  resetSelectorButtons();
                  button.classList.add('is-selected');
                });
              });
            }
          },
          change() {
            if (!sliderPageButtons) return;
            resetSelectorButtons();
            const matchingSliderButton = Array.from(sliderPageButtons).find((button) => {
              const buttonSlideIndex = parseInt(button.dataset.pageButton, 10);
              return buttonSlideIndex === this.selectedIndex;
            });
            matchingSliderButton?.classList.add('is-selected');
          },
        },
      };

      const flickity = new Flickity(slider, enableMarquee ? enabledConfig : disabledConfig);
      let requestId;

      // Animation functions
      const play = () => {
        if (!flickity) return;

        flickity.x -= 0.8;
        flickity.selectedIndex = flickity.dragEndRestingSelect();
        flickity.updateSelectedSlide();
        flickity.settle(flickity.x);
        requestId = window.requestAnimationFrame(play);
      };

      const pause = () => {
        if (!requestId) return;

        window.cancelAnimationFrame(requestId);
        requestId = undefined;
      };

      // Only initialize animation if slider is enabled
      if (enableMarquee) {
        // Pause on hover/focus
        slider.addEventListener('mouseenter', pause);

        // Unpause on mouse out / defocus
        slider.addEventListener('mouseleave', play);

        // Start the animation
        play();
      }

      // Clean up on section unload
      this.onUnload = () => {
        if (enableMarquee) {
          pause();
        }
        flickity.destroy();
      };
    },
  });
